/* CMNAV V6 – FX layer (Oct 2026). Progressive enhancements only: every feature below works as plain
   HTML/CSS when this file does not run. Rebuilt natively from 21st.dev community patterns
   (Text Rotate, Live-diagram bento, Spec Sheet, How-it-works timeline, Container Scroll, 3D card).
   Phone rows in the Why-us grid get an in-focus state (the row nearest the screen centre; beam in cmnav-fx.css).
   Respects prefers-reduced-motion. Safe to load once per page; re-runs on theme-editor section events. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('cmv-js')) root.classList.add('cmv-js');
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;

  /* ---- 1. Hero word rotate (21st.dev "Text Rotate") ---- */
  function rotate() {
    var els = document.querySelectorAll('.cmv-rotate[data-rotate]:not([data-rotate-ready])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-rotate-ready', '');
      var words = el.querySelectorAll('.cmv-rotate__word');
      if (words.length < 2 || reduce) return;
      var i = 0, timer = null, every = parseInt(el.getAttribute('data-interval'), 10) || 2800;
      function step() {
        var cur = words[i], next = words[(i + 1) % words.length];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        next.classList.remove('is-out'); next.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 600);
        i = (i + 1) % words.length;
      }
      function start() { if (!timer) timer = setInterval(step, every); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      if (hasIO) {
        new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }, { threshold: 0.1 }).observe(el);
      } else { start(); }
    });
  }

  /* ---- 2. Live diagram: play only when on screen; several scenes take turns (10 s each) ---- */
  function diagram() {
    var tiles = document.querySelectorAll('.cmv-tile--diagram:not([data-dg-ready])');
    Array.prototype.forEach.call(tiles, function (tile) {
      tile.setAttribute('data-dg-ready', '');
      var multi = tile.querySelector('.cmv-diagram-multi');
      var scenes = multi ? multi.querySelectorAll('.cmv-diagram') : [];
      var copies = tile.querySelectorAll('.cmv-dg-copy__item');
      var idx = 0, timer = null, every = (multi && parseInt(multi.getAttribute('data-seconds'), 10) || 10) * 1000;
      function show(i) {
        Array.prototype.forEach.call(scenes, function (sc, k) { sc.classList.toggle('is-on', k === i); });
        Array.prototype.forEach.call(copies, function (c, k) { c.classList.toggle('is-on', k === i); });
      }
      function start() { if (scenes.length > 1 && !reduce && !timer) timer = setInterval(function () { idx = (idx + 1) % scenes.length; show(idx); }, every); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if (scenes.length || copies.length) show(0);
      /* theme editor: clicking a scene block jumps to that scene and holds it for a full loop */
      document.addEventListener('shopify:block:select', function (ev) {
        var id = ev.detail && ev.detail.blockId; if (!id) return;
        var k = -1; Array.prototype.forEach.call(scenes, function (sc, n) { if (sc.getAttribute('data-block') === id) k = n; });
        if (k < 0) return;
        idx = k; show(-1); void tile.offsetWidth; show(idx); stop(); start();
      });
      if (!hasIO || reduce) { tile.classList.add('is-live'); start(); return; }
      /* leaving the screen stops every animation; coming back restarts the current scene from the top, in step with the timer */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { tile.classList.toggle('is-live', en.isIntersecting); if (en.isIntersecting) start(); else stop(); });
      }, { threshold: 0.25 }).observe(tile);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); return; }
        if (tile.classList.contains('is-live')) { if (scenes.length) { show(-1); void tile.offsetWidth; show(idx); } start(); }
      });
    });
  }

  /* ---- 3. Compare the range: segmented controls, differences-only switch, count-up facts ---- */
  function compare() {
    var blocks = document.querySelectorAll('.cmv-cmp:not([data-cmp-ready])');
    Array.prototype.forEach.call(blocks, function (cmp) {
      cmp.setAttribute('data-cmp-ready', '');
      /* segmented controls */
      Array.prototype.forEach.call(cmp.querySelectorAll('.cmv-seg'), function (seg) {
        var key = seg.getAttribute('data-seg');
        Array.prototype.forEach.call(seg.querySelectorAll('.cmv-seg__btn'), function (btn) {
          btn.addEventListener('click', function () {
            Array.prototype.forEach.call(seg.querySelectorAll('.cmv-seg__btn'), function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
            cmp.setAttribute('data-' + key, btn.getAttribute('data-value'));
            announce(cmp, btn.getAttribute('data-announce') || '');
          });
        });
      });
      /* differences only */
      var sw = cmp.querySelector('.cmv-switch');
      var rows = cmp.querySelectorAll('tbody tr[data-row]');
      function applyDiff(on) {
        var shown = 0;
        Array.prototype.forEach.call(rows, function (tr) {
          var cells = tr.querySelectorAll('td[data-v]'), first = null, same = true;
          Array.prototype.forEach.call(cells, function (td) { var v = td.getAttribute('data-v'); if (first === null) first = v; else if (v !== first) same = false; });
          var hide = on && same && cells.length > 1;
          tr.classList.toggle('is-same', hide);
          if (!hide) shown++;
        });
        /* hide group headings whose rows are all hidden */
        Array.prototype.forEach.call(cmp.querySelectorAll('tbody tr.cmv-cmp__group'), function (g) {
          var next = g.nextElementSibling, any = false;
          while (next && !next.classList.contains('cmv-cmp__group')) { if (!next.classList.contains('is-same')) any = true; next = next.nextElementSibling; }
          g.classList.toggle('is-same', !any);
        });
        cmp.classList.toggle('is-all-same', shown === 0);
      }
      if (sw) {
        sw.addEventListener('click', function () {
          var on = sw.getAttribute('aria-checked') !== 'true';
          sw.setAttribute('aria-checked', on ? 'true' : 'false');
          applyDiff(on);
          announce(cmp, on ? 'Showing only the rows that differ between models.' : 'Showing every row.');
        });
        applyDiff(sw.getAttribute('aria-checked') === 'true');
      }
      /* count-up facts (21st.dev "Stats") */
      var nums = cmp.querySelectorAll('.cmv-fact__num[data-count]');
      function countUp(el) {
        var target = parseInt(el.getAttribute('data-count'), 10) || 0, t0 = null, dur = 1100;
        var out = el.querySelector('[data-num]') || el;
        if (reduce) { out.textContent = target; return; }
        function frame(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur); p = 1 - Math.pow(1 - p, 3);
          out.textContent = Math.round(target * p);
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }
      if (nums.length) {
        if (!hasIO || reduce) { Array.prototype.forEach.call(nums, countUp); }
        else {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); io.unobserve(en.target); } });
          }, { threshold: 0.4 });
          Array.prototype.forEach.call(nums, function (n) { io.observe(n); });
        }
      }
    });
  }
  function announce(scope, text) {
    var live = scope.querySelector('[data-cmp-live]');
    if (live && text) { live.textContent = ''; setTimeout(function () { live.textContent = text; }, 30); }
  }

  /* ---- 4. How it works: connector + numbers in sequence ---- */
  function steps() {
    var els = document.querySelectorAll('.cmv-steps[data-fx-steps]:not([data-steps-ready])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-steps-ready', '');
      if (!hasIO || reduce) { el.classList.add('is-on'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { el.classList.add('is-on'); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }

  /* ---- 5. Video container scroll tilt (Aceternity "Container Scroll Animation") ---- */
  function tilt() {
    if (reduce || !mq('(min-width: 860px)')) return;
    var els = document.querySelectorAll('.dynamic-video-wrapper .dynamic-video:not([data-tilt-ready])');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) { el.setAttribute('data-tilt-ready', ''); });
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 800;
      Array.prototype.forEach.call(els, function (el) {
        var r = el.getBoundingClientRect();
        /* progress 0 when the card's top enters at the bottom of the screen, 1 when it reaches ~30% from the top */
        var p = (vh - r.top) / (vh * 0.7);
        p = Math.max(0, Math.min(1, p));
        var e = 1 - Math.pow(1 - p, 2);
        el.style.setProperty('--cmv-tilt', (14 * (1 - e)).toFixed(2) + 'deg');
        el.style.setProperty('--cmv-tilt-scale', (0.94 + 0.06 * e).toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---- 6. Category tiles: 3D hover (mouse only) ---- */
  function tilt3d() {
    if (reduce || !mq('(hover: hover) and (pointer: fine)')) return;
    var tiles = document.querySelectorAll('.promo-grid--inner .promo-block:not([data-tilt3d-ready])');
    Array.prototype.forEach.call(tiles, function (t) {
      t.setAttribute('data-tilt3d-ready', '');
      t.classList.add('cmv-tilt3d');
      t.addEventListener('pointermove', function (ev) {
        var r = t.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        t.classList.add('is-hover');
        t.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg');
        t.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      t.addEventListener('pointerleave', function () {
        t.classList.remove('is-hover');
        t.style.setProperty('--rx', '0deg'); t.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---- 7. Phones: the Why-us row nearest the middle of the screen is "in focus" (border beam + amber icon) ---- */
  var rowsBound = false;
  function rows() {
    if (!mq('(max-width: 600px)')) return;
    var fresh = document.querySelectorAll('.cmv-bento .cmv-tile:not(.cmv-tile--feature):not([data-row-ready])');
    Array.prototype.forEach.call(fresh, function (t) { t.setAttribute('data-row-ready', ''); });
    if (!fresh.length && rowsBound) return;
    var ticking = false;
    function update() {
      ticking = false;
      var tiles = document.querySelectorAll('.cmv-bento .cmv-tile[data-row-ready]');
      if (!tiles.length) return;
      var vh = window.innerHeight || 800, mid = vh / 2, best = null, bestD = Infinity;
      Array.prototype.forEach.call(tiles, function (t) {
        var r = t.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bestD) { bestD = d; best = t; }
      });
      Array.prototype.forEach.call(tiles, function (t) { t.classList.toggle('is-focus', t === best && bestD < vh * 0.32); });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    if (!rowsBound) {
      rowsBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    update();
  }

  /* ---- 8. "See it find the way": one continuous 32 s story; CSS keyframes do the work, this just plays/pauses it ---- */
  function journey() {
    var els = document.querySelectorAll('.cmv-journey:not([data-jr-ready])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-jr-ready', '');
      if (!hasIO || reduce) { el.classList.add('is-live'); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          /* toggling the class off then on restarts every CSS animation on it from the top */
          if (en.isIntersecting) { el.classList.add('is-live'); }
          else { el.classList.remove('is-live'); }
        });
      }, { threshold: 0.3 }).observe(el);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { el.classList.remove('is-live'); return; }
        if (el.getBoundingClientRect().top < window.innerHeight && el.getBoundingClientRect().bottom > 0) el.classList.add('is-live');
      });
    });
  }

  function init() { rotate(); diagram(); compare(); steps(); tilt(); tilt3d(); rows(); journey(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:reorder', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:block:select', function () { setTimeout(init, 60); });
})();
